import { render, staticRenderFns } from "./c_news_roll.vue?vue&type=template&id=0bdc8c24&scoped=true"
import script from "./c_news_roll.vue?vue&type=script&lang=js"
export * from "./c_news_roll.vue?vue&type=script&lang=js"
import style0 from "./c_news_roll.vue?vue&type=style&index=0&id=0bdc8c24&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdc8c24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/crmeb/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bdc8c24')) {
      api.createRecord('0bdc8c24', component.options)
    } else {
      api.reload('0bdc8c24', component.options)
    }
    module.hot.accept("./c_news_roll.vue?vue&type=template&id=0bdc8c24&scoped=true", function () {
      api.rerender('0bdc8c24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfig/c_news_roll.vue"
export default component.exports